"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphDocumentElement = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_redux_1 = require("react-redux");
const document_1 = require("../../../../../../reducers/slices/document/document");
const font_sizes_weights_1 = require("../../../../../../constants/font_sizes_weights");
const type = "Paragraph";
exports.ParagraphDocumentElement = {
    type,
    sideBarComponent: SideBarComponent,
    documentComponent: DocumentComponent,
    propertiesComponent: () => react_1.default.createElement("div", null, "Properties Components"),
    construct: (_id, page) => {
        return {
            _id,
            type,
            page,
            extra_attributes: {
                text: "Paragraph goes here...",
                size: 2,
                weight: 3,
                edit_type: "block",
            },
        };
    },
    sidebarBtnElement: {
        icon: pro_light_svg_icons_1.faParagraph,
        label: "Paragraph",
    },
};
function DocumentComponent({ elementInstance }) {
    var _a, _b, _c;
    const dispatch = (0, react_redux_1.useDispatch)();
    return (react_1.default.createElement("p", { className: `my-4 block field-content-scale ${font_sizes_weights_1.SIZES[(_a = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _a === void 0 ? void 0 : _a.size]} ${font_sizes_weights_1.WEIGHTS[(_b = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _b === void 0 ? void 0 : _b.weight]}` }, (_c = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _c === void 0 ? void 0 : _c.text));
}
function SideBarComponent({ elementInstance }) {
    var _a, _b, _c;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [text, setText] = (0, react_1.useState)((_a = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _a === void 0 ? void 0 : _a.text);
    const [fontSize, setFontSize] = (0, react_1.useState)(String((_b = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _b === void 0 ? void 0 : _b.size));
    const [fontWeight, setFontWeight] = (0, react_1.useState)(String((_c = elementInstance === null || elementInstance === void 0 ? void 0 : elementInstance.extra_attributes) === null || _c === void 0 ? void 0 : _c.weight));
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex justify-evenly gap-4" },
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.DropdownControl, { label: "Font Size", size: "small", options: (0, font_sizes_weights_1.SIZE_ARRAY)(), value: fontSize, borderColor: "border-slate-400", textColor: "text-slate-400", labelColor: "text-slate-400", iconColor: "text-slate-400", onChange: (value) => {
                        setFontSize(value);
                        dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, elementInstance), { extra_attributes: Object.assign(Object.assign({}, elementInstance.extra_attributes), { size: Number(value), text: text, weight: Number(fontWeight) }) })));
                    } })),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.DropdownControl, { label: "Font Weight", size: "small", options: (0, font_sizes_weights_1.WEIGHT_ARRAY)(), value: fontWeight, borderColor: "border-slate-400", textColor: "text-slate-400", labelColor: "text-slate-400", iconColor: "text-slate-400", onChange: (value) => {
                        setFontWeight(value);
                        dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, elementInstance), { extra_attributes: Object.assign(Object.assign({}, elementInstance.extra_attributes), { size: Number(fontSize), text: text, weight: Number(value) }) })));
                    } }))),
        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Text", size: "small", lines: 5, value: text, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(this, void 0, void 0, function* () {
                setText(e);
                dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, elementInstance), { extra_attributes: Object.assign(Object.assign({}, elementInstance.extra_attributes), { size: Number(fontSize), text: e, weight: Number(fontWeight) }) })));
            }) })));
}
